"use client";

import React from "react";
import { MapPin, Clock, Phone, Navigation } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function LaNostraPosizione() {
  return <section id="la-nostra-posizione" className="dark bg-background text-foreground relative w-full h-[600px] flex items-center justify-center md:justify-start overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50765.35034575291!2d13.060000000000002!3d37.508000000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x131a61b6b6b6b6b7%3A0x40b042967b6b6b6!2sSciacca%20AG!5e0!3m2!1sit!2sit!4v1700000000000!5m2!1sit!2sit" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Mappa di Sciacca" className="w-full h-full grayscale-[20%] contrast-[1.1] opacity-90" />
      </div>

      {}
      <div className="relative z-10 w-full max-w-md px-4 md:ml-12 lg:ml-24">
        <Card className="bg-[hsl(36_33%_97%)]/90 backdrop-blur-md border-none shadow-2xl text-[hsl(24_35%_18%)] overflow-hidden">
          <CardHeader className="pb-2">
            <CardTitle className="text-3xl font-serif font-bold text-[hsl(24_35%_18%)]">
              Vieni a trovarci
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6 pt-4">
            <div className="flex items-start gap-4">
              <MapPin className="w-6 h-6 text-[hsl(24_35%_18%)] shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-lg">Indirizzo</h3>
                <p className="text-[hsl(24_35%_18%)]/80 leading-relaxed">Via dei Cappuccini, 31<br />92019 Sciacca AG, Italy</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Clock className="w-6 h-6 text-[hsl(24_35%_18%)] shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-lg">Orari di Apertura</h3>
                <p className="text-[hsl(24_35%_18%)]/80">Mar‑Sab: 7:30 – 19:00<div>Domenica: 7:30 – 14:00</div></p>
                <p className="text-sm text-[hsl(24_35%_18%)]/60 mt-1">Chiuso il Lunedì</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Phone className="w-6 h-6 text-[hsl(24_35%_18%)] shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-lg">Contatti</h3>
                <p className="text-[hsl(24_35%_18%)]/80">+39 0925 86986</p>
                <p className="text-[hsl(24_35%_18%)]/80">danielasabella099@gmail.com</p>
              </div>
            </div>

            <div className="pt-4">
              <Button asChild className="w-full bg-[hsl(24_35%_18%)] text-[hsl(36_33%_97%)] hover:bg-[hsl(24_35%_18%)]/90 shadow-md">
                <Link to="https://www.google.com/maps/search/?api=1&query=Sciacca+Sicilia" newTab>
                  <Navigation className="mr-2 h-4 w-4" />
                  Ottieni Indicazioni
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}